/**
 * The ink-wash front screens' fixed parts (ui/front.ts shows them round each screen): the brush 武
 * with its 九劍 caption, the title, the legend's opening in a narrow column beside a red seal and
 * the vertical 問劍無悔, and the build line. The painted scene behind them (smoke, taiji, the ink
 * sword dancers of loading/dancers.ts) is shared with the loading scene (#ink in index.html, loading/ink.css).
 *
 * Every Han glyph here is in UI_GLYPHS, and loading/warmup.ts loads its faces before the front shows:
 * the brush glyph from Ma Shan Zheng and the column from Noto Serif TC 500, both subset to these
 * glyphs; the seal is in the UI's own Han face (Noto Serif TC 900).
 */
import { LEGEND } from '@nine/shared';
import { h } from './dom';

/** Brush calligraphy (Ma Shan Zheng). */
export const BRUSH_HAN = '武';
/** The caption and the vertical heading (Noto Serif TC 500). */
export const COLUMN_HAN = '九劍問劍無悔';
/** The seal's four glyphs, read right to left in two columns (Noto Serif TC 900). */
export const SEAL_HAN = '無問悔劍';

/** The brush 武 and its caption, then the title (two blocks: the login places them apart). */
export function inkBrand(): HTMLElement[] {
  const caption = h(
    'span',
    { class: 'fr-caption' },
    h('span', { lang: 'zh-Hant' }, COLUMN_HAN.slice(0, 2)),
    h('i'),
  );
  // Calligraphy as decoration: the title below is the heading read out.
  const mark = h('div', { class: 'fr-mark' }, h('span', { class: 'fr-wu', lang: 'zh' }, BRUSH_HAN), caption);
  mark.setAttribute('aria-hidden', 'true');
  return [
    mark,
    h(
      'div',
      { class: 'fr-heading' },
      h('h1', {}, 'เก้ากระบี่ออนไลน์'),
      h('p', { class: 'fr-en', lang: 'en' }, 'NINE SWORDS'),
    ),
  ];
}

/** The legend's opening beside the seal and the vertical name of the sword saint. */
export function inkLegend(): HTMLElement {
  const prologue = LEGEND[0]!;
  const seal = h(
    'span',
    { class: 'fr-seal', lang: 'zh-Hant' },
    ...[...SEAL_HAN].map((g) => h('span', {}, g)),
  );
  seal.setAttribute('aria-hidden', 'true');
  return h(
    'aside',
    { class: 'fr-legend' },
    h('article', {}, h('h2', {}, prologue.title), h('p', {}, prologue.text[0] ?? '')),
    h(
      'div',
      { class: 'fr-column' },
      seal,
      h('span', { class: 'fr-vert', lang: 'zh-Hant' }, COLUMN_HAN.slice(2)),
      h('i'),
    ),
  );
}

/** The build line in the corner. */
export function inkVersion(): HTMLElement {
  return h('p', { class: 'fr-ver', lang: 'en' }, 'PHASE 1 · CORE GAMEPLAY');
}
